module.exports = __webpack_public_path__ + "img/1.mobile.7aa5b938.png";